import styled from 'styled-components'
import CloseIconImage from '../../assets/icons/CloseIcon.svg'

export const CloseIcon = styled.img.attrs({
    src: CloseIconImage,
})`
    cursor: pointer;
    width: 13px;
    height: 13px;
`
